import(/* webpackMode: "eager", webpackExports: ["SidebarList"] */ "/vercel/path0/components/generic/sidebar-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/vercel/path0/components/generic/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IconPlus"] */ "/vercel/path0/components/ui/icons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.2.4_@babel+core@7.28.0_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
